import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { SurveyStore } from '@gamiphy/loyalty-station-desktop/store/survey';
import { GameStore } from '@gamiphy/loyalty-station-desktop/store/game';
import { Trans } from '@gamiphy/react-i18n';
import { cardContentClasses } from '@mui/material/CardContent';
import { cardHeaderClasses } from '@mui/material/CardHeader';
import { WelcomeGiftCard } from '../components/welcomeGift/card';
import { SurveyCard, GameCard } from '../components/welcomeGift/tab/cards';
import { Tabs } from '../store/ui';
import Tab from '../components/cashback/cashbackProgram/loggedIn/components/Tab';

const LegacyWelcomeGiftTab: React.FC = () => {
  const showSurvey = React.useMemo(
    () => SurveyStore.isAvailable && SurveyStore.appSurvey && !SurveyStore.completed,
    [SurveyStore.isAvailable, SurveyStore.appSurvey, SurveyStore.completed],
  );

  const showGame = React.useMemo(
    () => GameStore.hasGames && !GameStore.completed,
    [GameStore.hasGames, GameStore.completed],
  );

  return (
    <Tab
      tab={Tabs.WelcomeGift}
      header={(
        <Typography fontSize={16} fontWeight={700}>
          <Trans
            i18nKey="user.welcomeGift"
            defaults="Welcome gift"
            components={{
              lowercase: <span style={{ textTransform: 'lowercase' }} />,
            }}
          />
        </Typography>
    )}
    >
      <Box>
        <Grid container direction="column" rowSpacing={1}>
          <Grid
            item
            sx={{
              '& > div': {
                borderRadius: 0,
                boxShadow: 'none',
                [`& .${cardContentClasses.root}`]: { px: 0 },
                [`& .${cardHeaderClasses.root}`]: { p: 0 },
              },
            }}
          >
            <WelcomeGiftCard />
          </Grid>
          {(showSurvey || showGame) && (
          <Grid container direction="column" item rowSpacing={2}>
            {showSurvey && (
            <Grid item>
              <SurveyCard hasIcon />
            </Grid>
            )}
            {showGame && (
            <Grid item>
              <GameCard hasIcon />
            </Grid>
            )}
          </Grid>
          )}
        </Grid>
      </Box>
    </Tab>

  );
};

export default LegacyWelcomeGiftTab;
